module.exports = __webpack_public_path__ + "static/media/b6.e822fab2.PNG";